import { inputStyles } from '@/styles/input';
import { cn } from '@/utils/cn';
import { FontAwesomeIcon } from '@/components/Common/FontAwesomeIcon/FontAwesomeIcon';

interface InputProps {
  type?: string;
  name?: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  error?: string;
  rightIcon?: () => React.ReactNode;
  leftIcon?: string;
  onBlur?: () => void;
  disabled?: boolean;
  maxLength?: number;
  inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode'];
  autoComplete?: string;
  onFocus?: () => void;
}

export const Input = ({
  type,
  name,
  placeholder,
  value,
  onChange,
  className,
  error,
  rightIcon,
  leftIcon,
  onBlur,
  disabled,
  maxLength,
  inputMode,
  autoComplete,
  onFocus,
}: InputProps) => {
  const testId = `input-${placeholder.toLowerCase().replace(/\s+/g, '-')}`;
  return (
    <div className="flex flex-col gap-1 w-full">
      <div className="relative w-full">
        <input
          data-testid={testId}
          type={type}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          disabled={disabled}
          maxLength={maxLength}
          inputMode={inputMode}
          autoComplete={autoComplete}
          className={cn(
            inputStyles,
            className,
            rightIcon && 'w-full pr-10 focus:border-muted-foreground active:border-muted-foreground',
            leftIcon && 'pl-10',
            error && 'border-danger text-danger active:border-danger focus:border-danger'
          )}
        />
        {rightIcon && (
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">{rightIcon()}</div>
        )}
        {leftIcon && (
          <div className="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none text-lg">
            <FontAwesomeIcon
              icon={leftIcon}
              className="text-lg"
              style={{ color: error ? 'var(--color-danger)' : 'var(--color-muted-foreground)' }}
            />
          </div>
        )}
      </div>
      {error && (
        <div data-testid={`${testId}-error`} className="text-xs text-red-500 min-h-[1.25rem]">
          {error}
        </div>
      )}
    </div>
  );
};
